/**
 * Time-clock activities — the one list every time screen uses: the order's
 * Time Clocks tab, the Time Clocks page, the timer bar, and the switch, edit
 * and manual-entry dialogs (each used to keep its own copy, and they had
 * drifted). Colors are the App.css --time-* tokens; the soft background is
 * mixed from the same token over the surface, so dark mode follows.
 */
const category = (label, token) => ({
  label,
  color: `var(${token})`,
  bg: `color-mix(in srgb, var(${token}) 14%, var(--surface))`,
});

export const TIME_CATEGORIES = {
  labor: category("Labor", "--time-labor"),
  drive: category("Drive Time", "--time-drive"),
  break: category("Break", "--time-break"),
  left_for_parts: category("Left for Parts", "--time-parts"),
  lunch: category("Lunch", "--time-lunch"),
  training: category("Training", "--time-training"),
  comeback: category("Comeback", "--time-comeback"),
  admin: category("Admin", "--time-admin"),
};

/** How a category shows (an unknown or missing one shows as Labor). */
export const timeCategory = (key) => TIME_CATEGORIES[key] || TIME_CATEGORIES.labor;

/** Picker options [{ value, label, color, bg }] for `keys`, in that order. */
export const timeCategoryOptions = (keys) => keys.map((value) => ({ value, ...TIME_CATEGORIES[value] }));
